<template>
  <nav class="nav">
    <div class="nav__logo">
      <BaseIcon
        icon="addlogo"
        class="nav__svg"
      />
    </div>
    <ul class="navSidebar">
      <li
        v-for="(nav, navIndex) in filteredNavItems"
        :key="navIndex"
        class="navSidebar__item"
      >
        <p
          class="navSidebar__title"
          v-if="nav.title"
        >
          {{ nav.title }}
        </p>
        <ul class="nav__list">
          <router-link
            v-for="(sub, subIndex) in nav.children"
            :key="subIndex"
            tag="li"
            class="nav__item"
            :class="{'nav__item--active' : subIndex === activeNav && navIndex === activeNavSection }"
            :to="{name: sub.route}"
          >
            <span class="nav__icon">
              <font-awesome-icon
                :icon="sub.icon"
                v-if="sub.icon"
              />
            </span>
            <p class="nav__link">
              {{ sub.title }}
            </p>
          </router-link>
        </ul>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseIcon from './BaseIcon.vue';

export default {
    name: 'AppNavigation',
    components: { BaseIcon },
    data() {
        return {
            activeNav: 0,
            activeNavSection: 0,
            navItems: [
                {
                    title: 'Medicin',
                    children: [
                        { icon: 'pills', title: 'Præparater', route: 'preparations' },
                        { icon: 'notes-medical', title: 'Indholdsstoffer', route: 'substances' },
                        { icon: 'edit', title: 'Medicinændringer', route: 'importdata' },
                    ],
                },
                {
                    title: 'Administration',
                    children: [
                        { icon: 'sticky-note', title: 'Globale noter', route: 'global-notes' },
                        { icon: 'syringe', title: 'Administrationsveje', route: 'route-of-administation' },
                        { icon: 'shield-alt', title: 'WADA klassificeringer', route: 'wada-classification' },
                    ],
                },
                {
                    title: 'System',
                    children: [
                        { icon: 'comments', title: 'Notifikationer', route: 'notifications' },
                        { icon: 'spell-check', title: 'Ordbog', route: 'dictionary' },
                        {
                            icon: 'users', title: 'Brugere', route: 'users', admin: true,
                        },
                        {
                            icon: 'key', title: 'API-nøgler', route: 'api-keys', admin: true,
                        },
                    ],
                },
            ],
        };
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
        }),
        filteredNavItems() {
            return this.navItems.map((nav) => {
                const childs = nav.children.filter((child) => {
                    if (child.admin) {
                        if (!this.user) {
                            return false;
                        }

                        return this.user.isAdministrator;
                    }

                    return true;
                });

                return { ...nav, children: [...childs] };
            });
        },
    },
    methods: {
        detectActiveRoute() {
            let sectionIndex = 0;
            let navIndex = 0;

            const currentRoute = this.$route.name.split('.')[0];

            this.filteredNavItems.forEach((category, categoryIndex) => {
                const tempNavIndex = category.children.findIndex(child => child.route.indexOf(currentRoute) > -1);

                if (tempNavIndex > -1) {
                    navIndex = tempNavIndex;
                    sectionIndex = categoryIndex;
                }
            });

            this.activeNavSection = sectionIndex;
            this.activeNav = navIndex;
        },
    },
    created() {
        this.detectActiveRoute();
    },
    watch: {
        $route() {
            this.detectActiveRoute();
        },
    },
};
</script>

<style lang="scss" scoped>
.navSidebar {
    &__item {
        // &:not(:first-child) {
            margin-top: 10px;
        // }
    }
    &__title {
        font-weight: bold;
        text-transform: uppercase;
        padding-left: 28px;
        padding-top: 10px;
        padding-bottom: 10px;
        letter-spacing: 1px;
        font-size: 12px;
        color: #e6c1c8;
        user-select: none;
    }
}

.nav {
  background: #9c0c27;
  color: $gray2;
  max-width: 250px;
  width: 100%;

  &__logo {
    height: $headerHeight;
    background: $white;

    svg {
      max-height: $headerHeight;
      padding: 15px 0;
      fill: $brand;
      width: 100%;
    }
  }
  &__list {
    overflow: auto;
    height: calc(100% - #{$headerHeight});
  }
  &__item {
    padding-left: 28px;
    display: flex;
    align-items: center;
    user-select: none;
    cursor: pointer;
    background-color: $brand;
    // border-left: 2px solid #9c0c27;

    &:not(:last-child) {
      border-bottom: 2px solid #9c0c27;
    }

    &:not(.nav__item--active):hover {
    //   border-left: 2px solid $white;
      background: #b80f2e;
    }

    &--active {
      background: #b80f2e;
    //   border-left: 2px solid $white;
    }
  }
  &__icon {
    padding-right: 16px;
    width: 30px;
  }
  &__link {
    padding: 15px 0;
    display: inline-block;
  }
}
</style>
